import {useContext, useEffect} from 'react'
import {ReducerContext} from './reducer'
import {auth} from '../Auth'
import DB from '../DAL/DB'
import { isArray } from 'lodash'

const forms = new DB.Forms()
const rubrics = new DB.Rubrics()
const users = new DB.Users()

export default function useResources() {
  const {state, dispatch} = useContext(ReducerContext)

  useEffect(function () {
    forms.subscribe(
      undefined,
      {filters: [['organization.id', '==', auth.sunkaizenUser.organization.id]]},
      ({data: value}) => { 
        if(Array.isArray(value) && value.length > 0) {
          const sortedByTitle = [...value].sort((a, b) => {
            const titleA = (a.title ?? "").toLowerCase();
            const titleB = (b.title ?? "").toLowerCase();
            if (titleA < titleB) return -1;
            if (titleA > titleB) return 1;
            return 0;
          })
          dispatch({type: 'forms', value: sortedByTitle})
        }  
      }
    )

    users.subscribe(undefined, {filters: [['type', '==', 'client']]}, ({data}) => {
      if (Array.isArray(data) && data.length > 0) {
        const sortedData = data.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase();
          const nameB = (b.name || "").toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        dispatch({type: 'clients', value: sortedData})
      }
    }
    )
  }, [])

  useEffect(
    function () {
      if (!state.form) return

      const unsubscribe = rubrics.subscribe(undefined, {filters: [['formId', '==', state.form]]}, ({data: value}) => {
        if(Array.isArray(value) && value.length > 0) { 
          const sortedData = [...value].sort((a, b) => {
            const nameA = (a.name || "").toLowerCase();
            const nameB = (b.name || "").toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          dispatch({type: 'rubrics', value: sortedData})
        }
      })

      return unsubscribe
    },
    [state.form]
  )
}
